const camelize = s => s.replace(/_(\w)/g, (_, m1) => m1.toUpperCase());

const parseQueryString = queryString =>
  queryString
    ? queryString
        .substring(1)
        .split('&')
        .map(string => {
          const [key, value] = string.split('=');
          return {
            [camelize(key)]: decodeURIComponent(value),
          };
        })
        .reduce((prev, curr) => ({ ...prev, ...curr }), {})
    : {};

export default parseQueryString;
